import getLastNews from "./getLastNews";

export default function () {
    let prevPreloder = document.getElementById('infinit-scroll-preloader');
    if (prevPreloder) {
        prevPreloder.remove();
    }

    let preloaderWrapper = document.createElement('div');
    preloaderWrapper.classList.add('page-load-status');
    preloaderWrapper.innerHTML = '' +
        '<div id="infinit-scroll-preloader" class="loader-ellips">\n' +
        '  <span class="loader-ellips__dot"></span>\n' +
        '  <span class="loader-ellips__dot"></span>\n' +
        '  <span class="loader-ellips__dot"></span>\n' +
        '  <span class="loader-ellips__dot"></span>\n' +
        '</div>'

    getLastNews().appendChild(preloaderWrapper);
}
